export const BONUS_TRANSFER = 'bonus_transfer';
